export default function Modules() {
  const modules = [
    {
      title: 'Diagnóstico e Mapeamento',
      duration: 'Meses 1-2',
      items: [
        'Análise completa da situação atual',
        'Mapeamento de processos críticos',
        'Identificação de gargalos',
        'Levantamento de dores e oportunidades',
        'Avaliação de maturidade organizacional'
      ],
      color: 'from-coral-500 to-coral-600'
    },
    {
      title: 'Planejamento Estratégico',
      duration: 'Meses 3-4',
      items: [
        'Priorização de melhorias',
        'Criação de roadmap personalizado',
        'Definição de metas e indicadores',
        'Plano de ação detalhado',
        'Alinhamento de expectativas'
      ],
      color: 'from-primary-500 to-primary-600'
    },
    {
      title: 'Implementação Fase 1',
      duration: 'Meses 5-7',
      items: [
        'Execução de melhorias prioritárias',
        'Otimização de processos críticos',
        'Implementação de ferramentas',
        'Capacitação da equipe',
        'Acompanhamento semanal'
      ],
      color: 'from-purple-500 to-purple-600'
    },
    {
      title: 'Implementação Fase 2',
      duration: 'Meses 8-10',
      items: [
        'Refinamento de processos',
        'Automações e integrações',
        'Ajustes baseados em dados',
        'Expansão de melhorias',
        'Monitoramento de KPIs'
      ],
      color: 'from-orange-500 to-orange-600'
    },
    {
      title: 'Consolidação e Escala',
      duration: 'Meses 11-12',
      items: [
        'Estabilização de processos',
        'Documentação completa',
        'Preparação para crescimento',
        'Transferência de conhecimento',
        'Plano de continuidade'
      ],
      color: 'from-green-500 to-green-600'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Módulos do Programa
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Estrutura completa dividida em 5 módulos progressivos para garantir 
            resultados consistentes e sustentáveis
          </p>
        </div>

        <div className="space-y-6">
          {modules.map((module, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer group"
            >
              <div className="flex flex-col lg:flex-row gap-8">
                {/* Left Side - Header */}
                <div className="lg:w-1/3">
                  <div className={`inline-block px-4 py-2 bg-gradient-to-r ${module.color} text-white rounded-full text-sm font-semibold mb-4`}>
                    {module.duration}
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4 group-hover:text-coral-500 transition-colors">
                    {module.title}
                  </h3>
                  <div className="w-16 h-1 bg-coral-500 rounded-full"></div>
                </div>

                {/* Right Side - Content */}
                <div className="lg:w-2/3">
                  <ul className="space-y-4">
                    {module.items.map((item, itemIndex) => (
                      <li key={itemIndex} className="flex items-start gap-3">
                        <div className="w-6 h-6 bg-coral-500/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                          <i className="ri-check-line text-coral-500 text-sm"></i>
                        </div>
                        <span className="text-gray-700 text-lg">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-12 bg-gradient-to-r from-primary-600 to-primary-700 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">
            Acompanhamento Mensal Personalizado
          </h3>
          <p className="text-lg opacity-90 max-w-3xl mx-auto">
            Durante todo o programa você terá reuniões mensais de acompanhamento, 
            relatórios de evolução, suporte via WhatsApp e acesso a ferramentas exclusivas
          </p>
        </div>
      </div>
    </section>
  );
}
